export default {
  // 위험평가 항목 제안 결과
  riskSubtasks: null,

  // 재난 유형 정의 결과
  riskType: null,

  // 현재 안전보건조치 제안 결과
  currentSafetyMeasures: null,

  // 현재 위험도 점수 제안 결과
  currentRiskPoint: null,

  // 위험감소대책 제안 결과
  riskReductions: null,

  // 개선후 위험도 점수 제안 결과
  afterRiskPoint: null,

  // 이미지 기반 위험성평가 분석 결과
  imageRiskAnalysis: null,

  // AI 음성/텍스트 통역 결과
  voiceTranslateResult: null
}
